
import { Options, Vue, Prop } from "vue-property-decorator";
const views = ["minutes", "hours"];
import UiMinuteSelector from "@views/components/ui-time-range-selector/ui-minute-selector.vue";
import UiHourSelector from "@views/components/ui-time-range-selector/ui-hour-selector.vue";
@Options<UiTimeRangeSelector>({
  watch: {
    maximumView(value) {
      this.validateViewRanges();
    },
    minimumView(value) {
      this.validateViewRanges();
    },
    minDate(value) {
      if (this.linkedDatePicker) {
        return this.linkedDatePicker;
      }
      return this.minimumDate;
    },
  },
  components: { UiHourSelector, UiMinuteSelector },
})
export default class UiTimeRangeSelector extends Vue {
  @Prop({ default: new Date(), type: Date }) date: Date;
  @Prop({ default: new Date(), type: Date }) dateSecond: Date;
  @Prop({ default: null, type: Date }) minimumDate: Date;
  // ограничение даты сверху
  @Prop({ default: null, type: Date }) maximumDate: Date;
  minimumView = "hours";
  maximumView = "hours";
  initialView = "hours";
  @Prop({ default: null, type: String }) linkedDatePickerName: String;
  isDateRange = true;
  @Prop({ default: true }) showCurrentDate: boolean;

  innerCurrentView = this.getInitialView();
  innerDay: number = null;
  innerMonth: number = null;
  innerYear: number = null;
  innerHour: number = null;
  innerMinute: number = null;
  innerDate: Date = null;
  linkedDatePicker;
  created() {
    this.innerCurrentView = this.getInitialView();
    this.innerDay = this.date.getDate();
    this.innerMonth = this.date.getMonth();
    this.innerYear = this.date.getFullYear();
    this.innerHour = this.date.getHours();
    this.innerMinute = this.date.getMinutes();
    this.innerDate = this.date;
    this.validateViewRanges();
    this.innerCurrentView = this.getInitialView();
    this.linkedDatePicker = this.linkedDatePickerName;
  }
  mounted() {
    this.linkedDatePicker = this.linkedDatePickerName;
    this.validateViewRanges();
  }

  validateViewRanges() {
    var invalid =
      views.indexOf(this.minimumView) > views.indexOf(this.maximumView);
    if (invalid) {
      console.error(
        `Maximumview не может быть меньше minimumView. Maximumview=${this.maximumView}, minimumview=${this.minimumView}`
      );
    }
  }

  NavigatorDatetime(typeView: any) {
    if (this.allowedToShowView(typeView)) {
      this.innerCurrentView = typeView;
    }
  }

  ChangeDatetime(typeView: any, type: string) {
    if (this.allowedToShowView(typeView)) {
      this.ChangeCurrentView(typeView);
    }
  }
  /**
   * Изменить текущее представление
   */
  ChangeCurrentView(typeView: any) {
    this.innerCurrentView = typeView;
  }

  getInitialView(): String {
    if (!this.initialView) return this.maximumView;
    return this.initialView;
  }
  /**
   * Разрешено ли открытие представления
   */
  allowedToShowView(view: any) {
    let minimumViewIndex = views.indexOf(this.minimumView);
    let maximumViewIndex = views.indexOf(this.maximumView);
    let viewIndex = views.indexOf(view);
    return viewIndex >= minimumViewIndex && viewIndex <= maximumViewIndex;
  }
  getRequest() {
    return this.date;
  }
}
